import { useQuery } from '@tanstack/react-query';

import { apiClient } from 'shared/client/apiClient';
import { GetAssignmentRequestType, GetAssignmentResponseType } from 'shared/common/dtos/lms/getAssignment';

export const getAssignment = async (getAssignmentDto: GetAssignmentRequestType) => {
  const { data } = await apiClient.GET('/lms/assignments/{assignmentId}', {
    params: { path: { assignmentId: getAssignmentDto.assignmentId } }
  });
  return (data ?? null) as GetAssignmentResponseType | null;
};

export const useGetAssignmentQuery = (getAssignmentDto: GetAssignmentRequestType, enabled: boolean) => {
  return useQuery<GetAssignmentResponseType | null>({
    queryKey: ['assignment-info', { assignmentId: getAssignmentDto.assignmentId }],
    queryFn: () => getAssignment(getAssignmentDto),
    enabled
  });
};
